var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import Company from "./Company";
var Address = /** @class */ (function (_super) {
    __extends(Address, _super);
    function Address(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.line1 = '';
        _this.line2 = '';
        _this.city = '';
        _this.postalCode = '';
        _this.country = 'FR';
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Address.buildFromJson(_this, obj);
        return _this;
    }
    Address.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'company') {
                        instance[prop] = new Company(json[prop]);
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    Object.defineProperty(Address.prototype, "company", {
        get: function () {
            if (this._company === undefined || this._company === null)
                this._company = new Company();
            return this._company;
        },
        set: function (value) {
            this._company = value;
        },
        enumerable: false,
        configurable: true
    });
    Address.prototype.exportToJson = function () {
        var JSONAddress = {};
        JSONAddress['line1'] = this.line1;
        JSONAddress['line2'] = this.line2;
        JSONAddress['city'] = this.city;
        JSONAddress['postalCode'] = this.postalCode;
        JSONAddress['country'] = this.country;
        if (this._company) {
            JSONAddress['company'] = this._company.exportToJson();
        }
        return JSONAddress;
    };
    return Address;
}(Model));
export default Address;
//# sourceMappingURL=Address.js.map